import { Box, styled } from "@mui/material";
import { BoxProps } from "@mui/material/Box/Box";
import React from "react";

const StyledBox = styled(Box)(({ theme }) => ({
  ["::-webkit-scrollbar"]: {
    backgroundColor: "transparent",
    height: 5,
    width: 5,
  },
  ["::-webkit-scrollbar-thumb"]: {
    backgroundColor: theme.palette.grey[300],
    borderRadius: 2.5,
    ["&:hover"]: {
      backgroundColor: theme.palette.grey[400],
    },
  },
  ["::-webkit-scrollbar-track"]: {
    backgroundColor: "transparent",
  },
  overflow: "auto",
  scrollbarColor: `${theme.palette.grey[300]} transparent`,
  scrollbarWidth: "thin",
}));

interface ScrollableBoxProps extends BoxProps {
  scrollRef?: React.RefObject<HTMLDivElement>;
}

export const ScrollableBox: React.FC<ScrollableBoxProps> = ({
  scrollRef,
  ...props
}) => {
  return <StyledBox {...props} ref={scrollRef} />;
};
